import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './Roofing.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import AllServicesData from '../ServicesPage/AreaData'
import ReactCompareImage from "react-compare-image";
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import GenesisAiContent from "../GenesisAiContent/GenesisAiContent";
import emailjs from 'emailjs-com';
import img11 from '../../Images/11.jpg'
import img12 from '../../Images/12.jpg'
import img22 from '../../Images/roof1b.png'
import img23 from '../../Images/roof2b.png'

export default function Roofing({ CitiePhone, locationsMain, CitiesData }) {

    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);

    const fireRocketCall = () => {
        if (typeof window === "undefined") return;
        if (url.searchParams.get("spg") !== "o") return;
        if (typeof window.oaiq !== "function") return;
        const eventName = "rocket_roofing_phone_call";
        try {
            window.oaiq("measure", "custom", { type: "custom" }, {
                custom_event_name: eventName,
                event_id: `${eventName}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
            });
        } catch (e) { }
    };

    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [
            {
                "title": "WHY CHOOSE ROCKET ROOFING?",
                "content": "Rocket Roofing brings years of experience, skilled craftsmanship, and a dedication to quality. Our licensed professionals use premium materials and proven techniques to deliver durable, weather-resistant roofing solutions you can trust. We’re known for reliable service, fast response, and customer-first results."
            },
            {
                "title": "WHAT ROOFING SERVICES DO YOU OFFER?",
                "content": "We specialize in roof repair, roof replacement, new roof installation, leak detection, shingle replacement, flashing repair, and ongoing maintenance. Whether it’s a residential or commercial project, Rocket Roofing is your one-stop solution for top-tier roofing services."
            },
            {
                "title": "HOW MUCH DO YOUR SERVICES COST?",
                "content": "Roof repair services typically start at $199 depending on the scope of work. We offer free on-site inspections and detailed estimates, so you know exactly what needs attention and how much it will cost—before any work begins."
            },
            {
                "title": "CAN YOU REPAIR AND INSPECT ON THE SAME VISIT?",
                "content": "Yes! Our roofing experts come fully equipped to perform detailed inspections and handle common repairs on the spot. We aim to save you time and protect your property with fast, efficient service."
            },
            {
                "title": `DO YOU SERVICE ${CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "MY AREA"} AND NEARBY COMMUNITIES?`,
                "content": `Absolutely. We proudly serve ${CitiesData && CitiesData.City ? CitiesData.City : "your area"} and surrounding towns within a 75-mile radius. No matter where you're located, Rocket Roofing is ready to help with your roofing needs.`
            },
            {
                "title": "HOW DO I BOOK A ROOFING APPOINTMENT?",
                "content": `Booking with Rocket Roofing is quick and easy! Call us at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or use our <a href='#book'>online scheduling form</a>. We'll confirm your appointment and get your roofing service on the calendar.`
            },
            {
                "title": "HOW OFTEN SHOULD A ROOF BE INSPECTED?",
                "content": "We recommend a professional roof inspection once a year or after any major storm. Regular inspections help catch minor issues before they become expensive problems and extend the life of your roof."
            },
            {
                "title": "WHAT ARE THE SIGNS I NEED ROOF REPAIR?",
                "content": "Look for warning signs like missing shingles, ceiling leaks, mold growth, sagging, or debris in gutters. If you spot any of these, it’s time to call Rocket Roofing for a professional inspection and quick repair."
            }
        ]
    };

    const styles = {
        bgColor: '#FBF6E9',
        titleTextColor: '#182d43',
        titleTextSize: '18px',
        rowTitleColor: '#182d43',
        rowTitleTextSize: '19px',
        rowContentColor: '#242424',
        rowContentTextSize: '17px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const aiKd = url.searchParams.get('kd');
                const aiLoc = url.searchParams.get('open_ai_location');
                const aiCity = aiLoc ? aiLoc.split(',').map(p => p.trim().replace(/-/g, ' ')).join(', ') : '';
                const aiTopic = aiKd && aiKd !== 'null' ? aiKd : 'roofing';
                const searchKeyword = `I need from you 32 words about "${aiTopic}"${aiCity ? ` in ${aiCity}` : ''} and how we "Rocket Air Care" can help our clients with that kind of service. Give me that as a json file: title (3 words, include words from the service${aiCity ? ' and the city' : ''}, do not include the words "null" or "Rocket Air Care") and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })
                const dataChat = await resChat.json()
                console.log(dataChat.content)
                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }

            const getDerivedStateFromError = (error) => {
                console.log("123123");
                return { hasError: true };
            }
            const dsad = (error, errorInfo) => {
                console.log("123123");
            }
        })();
    }, []);
    return (
        <div className="Roofing" id="homepage">
            <Helmet>
                {/* <!-- TITLE --> */}
                <title>Rocket Air Care | Expert Roof Repair, Replacement & Inspection | 866-950-4606</title>

                {/* <!-- META TITLE (max 35 characters) --> */}
                <meta name="title" property="title" content="Rocket Air Care | Expert Roof Repair, Replacement & Inspection | 866-950-4606" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Rocket Air Care | Expert Roof Repair, Replacement & Inspection | 866-950-4606" data-react-helmet="true" />

                {/* <!-- META INFO --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="https://www.rocketaircare.com/og-roofing.jpg" data-react-helmet="true" />
                <meta name="og:url" property="og:url" content="https://www.rocketaircare.com/roofing" data-react-helmet="true" />

                {/* <!-- DESCRIPTION (title case) --> */}
                <meta name="description" content="Rocket Air Care Provides Professional Roof Repair, Full Roof Replacement, And Leak Inspections To Keep Your Home Safe, Dry, And Protected Year-Round." data-react-helmet="true" />
                <meta name="og:description" property="og:description" content="Rocket Air Care Provides Professional Roof Repair, Full Roof Replacement, And Leak Inspections To Keep Your Home Safe, Dry, And Protected Year-Round." data-react-helmet="true" />

                {/* <!-- SITE NAME --> */}
                <meta name="og:site_name" property="og:site_name" content="Rocket Air Care" data-react-helmet="true" />

                {/* <!-- KEYWORDS --> */}
                <meta name="keywords" content="Roof Repair, Roof Replacement, Roof Inspection, Emergency Roof Services, Storm Damage Roof Repair, Residential Roofing, Shingle Roof, Tile Roof, Flat Roof Repair, Leaking Roof Repair, Roofing Contractor, Local Roofers Near Me, Roof Leak Fix, Chimney Flashing Repair, New Roof Installation, Roof Maintenance, Roofing Estimates, Roof Services, Roof Tarping, Gutter Installation" data-react-helmet="true" />
            </Helmet>

            {/* MainBanner */}
            <div className="MainBanner" >
                <div className="MainBannerLeft">
                    <div className="MainBannerLeftRight">

                        <img className="bannerlogopng" src={require(`../../ImagesLogos/Logo1.png`)} />

                        <h1>Don't Sweat It, Call Rocket Air Care</h1>
                        <h4>Trusted <b>Roof Replacement Experts</b> in {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h4>
                        <h2>Rocket Air Care is the the leading Roofing team in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b>. Give us a call at <span>{CitiePhone}</span> to schedule your service.
                        </h2>
                        <h3><img src={require(`../../Images/check.png`)} />Affortable Pricing & No Hidden Fees</h3>
                        <h3><img src={require(`../../Images/check.png`)} />Licensed, Bonded, Insured!</h3>
                        <h3><img src={require(`../../Images/check.png`)} />Fully stocked trucks</h3>
                        <h3><img src={require(`../../Images/check.png`)} />1800+ 5-Star Reviews</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>Call Us Now!</a>
                            <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                        </div>
                        <div className="MainBannerLeftRated" >
                            <h3>Rated 5 on Google</h3>
                            <span>
                                <h4>5</h4>
                                <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                            </span>
                        </div>
                    </div>
                    <div className="MainBannerLeftLeft">
                        <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                    </div>

                </div>
                <div className="MainBannerImg">
                    <img src={require(`../../ImagesLogos/logobanner.png`)} />
                </div>
            </div>
            {/* RoofingReviews */}
            <div className="RoofingReviews" id="reviews">
                <h1>Read Our Latest 5-Star Reviews</h1>
                <div className="RoofingReviewsList">
                    <img className="bannerlogopng" src={require(`../../Images/roofingreview1.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/roofingreview2.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/roofingreview3.png`)} />
                </div>
            </div>
            {/* GenesisAiContent — keyword-driven section, /local ads pages only */}
            <GenesisAiContent response={response} />
            {/* RoofingBenefits */}
            <div className="RoofingBenefits">
                <h1>Benefits of Professional <span>Roofing Services</span></h1>

                <div className="RoofingBenefitsBox">
                    <div className="RoofingBenefitsBoxImg">
                        <img src={require(`../../Images/001-roofing.png`)} alt="Roof Leaks" />
                    </div>
                    <div className="RoofingBenefitsBoxBox">
                        <h2>Noticed Water Leaks or Stains?</h2>
                        <h3>Leaking roofs can lead to water damage, mold, and costly repairs. Our expert roofing team quickly identifies and seals leaks to protect your home and stop further interior damage.</h3>
                    </div>
                </div>

                <div className="RoofingBenefitsBox">
                    <div className="RoofingBenefitsBoxImg">
                        <img src={require(`../../Images/002-roof.png`)} alt="Missing Shingles" />
                    </div>
                    <div className="RoofingBenefitsBoxBox">
                        <h2>Missing or Damaged Shingles?</h2>
                        <h3>High winds, sun exposure, and aging can cause shingles to break or fall off. We replace damaged roofing materials to restore protection and keep your home energy-efficient.</h3>
                    </div>
                </div>

                <div className="RoofingBenefitsBox">
                    <div className="RoofingBenefitsBoxImg">
                        <img src={require(`../../Images/003-man.png`)} alt="Roof Mold or Algae" />
                    </div>
                    <div className="RoofingBenefitsBoxBox">
                        <h2>Worried About Roof Mold or Algae?</h2>
                        <h3>Dark stains or growth on your roof could signal moisture retention and algae. Our roofing professionals provide safe cleaning, repairs, and long-term solutions to prevent decay.</h3>
                    </div>
                </div>

                <div className="RoofingBenefitsBox">
                    <div className="RoofingBenefitsBoxImg">
                        <img src={require(`../../Images/004-roof-inspection.png`)} alt="High Energy Bills" />
                    </div>
                    <div className="RoofingBenefitsBoxBox">
                        <h2>Rising Energy Costs?</h2>
                        <h3>Aging or poorly insulated roofs let out heat and cooling, driving up utility bills. Our modern roofing solutions improve energy efficiency and reduce monthly expenses.</h3>
                    </div>
                </div>

                <h4>PROTECT YOUR HOME AND INVEST IN LASTING <span>ROOFING SOLUTIONS</span>—BOOK YOUR ROOF INSPECTION OR REPAIR TODAY!</h4>

                <div className="RoofingBenefitsbutn">
                    <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    <a href='#book'>SCHEDULE <span>&nbsp;ONLINE</span><img src={require(`../../Images/book.png`)} alt="Roof Repair | Roof Replacement | Roof Leak Services | Roofing In Master," /></a>
                </div>
            </div>
            {/* MainBanner2Top2 */}
            <div className="MainBanner2Top2">
                <div className="MainBanner2TopBoxMenuShadow1"></div>
                <div className="MainBanner2TopBoxMenu">

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roofrepair.png`)} alt="Roof Repair Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>ROOF REPAIR</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Leak Detection & Sealing</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Shingle Replacement</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Flashing Repair</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Storm Damage Fixes</h2>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roofreplacement.png`)} alt="Roof Replacement Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>ROOF REPLACEMENT</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Shingle Roof Replacement</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Tile & Metal Roofing</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Tear-Off & Installation</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Energy-Efficient Materials</h2>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roofinspection.png`)} alt="Roof Inspection Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>ROOF INSPECTION</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Annual Roof Checkups</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Storm Damage Assessment</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Real Estate Roof Reports</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Maintenance Planning</h2>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roofemergency.png`)} alt="Roof Leak Protection" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>LEAK PREVENTION</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Roof Waterproofing</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Gutter & Drainage Solutions</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Chimney Flashing Seals</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Interior Leak Protection</h2>
                        </div>
                    </a>

                </div>
                <div className="MainBanner2TopBoxMenuShadow2"></div>
            </div>

            {/* All home service categories — sub-categories grid */}
            {!location.pathname.startsWith("/local") && (<div className="CategoryBlocks CategoryBlocks-Hide-On-Local">
                {[
                    { key: "airduct", label: "Air Duct", href: "/airduct", match: (a) => /air duct|hvac duct|air vent|coil cleaning|mold removal from air|uv air|anti-microbial duct|indoor air quality|furnace cleaning/i.test(a.Title) },
                    { key: "chimney", label: "Chimney & Fireplace", href: "/chimney", match: (a) => /chimney|fireplace|creosote|smoke chamber|masonry|tuckpoint|wood stove|gas fireplace|pellet stove|insert/i.test(a.Title) },
                    { key: "dryer", label: "Dryer Vent", href: "/dryer", match: (a) => /dryer|lint|bird guard/i.test(a.Title) },
                    { key: "hvac", label: "HVAC", href: "/hvac", match: (a) => /hvac|^ac |furnace repair|furnace install|heat pump|mini-split|thermostat|refrigerant/i.test(a.Title) },
                    { key: "roofing", label: "Roofing & Gutters", href: "/roofing", match: (a) => /roof|gutter|skylight|soffit|fascia/i.test(a.Title) },
                ].map((cat) => {
                    const subs = AllServicesData.filter(cat.match).slice(0, 8);
                    if (subs.length === 0) return null;
                    return (
                        <div key={cat.key} className={`CategoryBlock CategoryBlock-${cat.key}`}>
                            <div className="CategoryBlockHeader">
                                <h2>{cat.label}</h2>
                                <a href={cat.href}>View {cat.label} Landing →</a>
                            </div>
                            <div className="CategoryBlockGrid">
                                {subs.map((s, i) => (
                                    <a key={i} href={s.Path} className="CategoryBlockItem">
                                        <h3>{s.Title}</h3>
                                        <p>{s.Full}</p>
                                        <span>Learn more →</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>)}

            {/* RoofingWeondawy */}
            <div className="RoofingWeondawy">
                <img src={require(`../../ImagesLogos/logobanner2.png`)} alt="Air Duct Cleaning" />
                <h1>Stay calm, we're coming to you!</h1>

            </div>
            {/* Roofingbefore */}
            <div className="RoofingBefore">
                <div className="RoofingBeforeLeft">
                    <h1>THE IMPORTANCE OF A WELL-MAINTAINED ROOF</h1>
                    <h2>Protect Your Property, Prevent Leaks, and Boost Energy Efficiency</h2>
                    <h3>Your roof is the first line of defense against the elements. Over time, weather, sun exposure, and natural wear can cause damage—leading to leaks, water intrusion, mold, and structural issues. A damaged or aging roof can also allow heat and air to escape, driving up your energy bills. Professional roof inspections, timely repairs, and full replacements ensure your home stays protected, efficient, and secure. Don’t wait for visible damage—schedule your roofing service today.</h3>

                    <h2>Stronger Roof, Safer Home—The Choice Is Clear</h2>
                    <h3>Roofing maintenance is not just about fixing leaks—it's about preserving your investment. Regular inspections and proactive service can help prevent costly repairs down the line, extend your roof’s lifespan, and maintain your home’s safety and value. Whether it’s a small patch or a full roof replacement, Rocket Roofing delivers dependable solutions you can trust. Take control of your home’s protection and comfort with expert roofing services today.</h3>

                    <h4>Booking with Rocket Roofing is simple! Call us at <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.</h4>
                </div>
                <div className="RoofingBeforeBox">
                    <ReactCompareImage leftImage={img22} rightImage={img23} />
                </div>
            </div>
            {/* HomePageGoogleBen */}
            <div className="HomePageGoogleBen">
                <div className="HomePageGoogleBenLEFT">
                    <img fetchpriority="low" src={require(`../../Images/Before1.jpeg`)} />
                </div>
                <div className="HomePageGoogleBenRIGHT">
                    <h1>ROCKET BENEFITS</h1>
                    <div className="HomePageGoogleBenRIGHTList">
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Highly Trained & Certified Technicians
                                <h3>- Our Technicians completed more than 2,500 hours of training in 2023</h3>
                                <h3>- Our Technicians complete 45+ hours yearly of weekly skills training</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Fast Response Time
                                <h3>- 24/7 emergency appointments available</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Satisfaction Guaranteed
                                <h3>- 1,800+ five-star reviews</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>Fully Licensed & Insured</h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>Friendly Customer Service</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* RoofingGoodBY */}
            <div className="RoofingGoodBY">
                <h1>SAY GOODBYE TO ROOF LEAKS AND COSTLY DAMAGE</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>Protect your home with expert roofing services from Rocket Roofing—repairs, inspections, and replacements you can trust.</h2>
                <div className="RoofingGoodBYList">
                    <img src={require(`../../Images/roof2.png`)} />
                    <img src={require(`../../Images/rooofbanner.png`)} />
                    <img src={require(`../../Images/roofcoad.png`)} />
                    <img src={require(`../../Images/roofinstall.png`)} />
                </div>
            </div>
            {/* MainBanner */}
            <div className="RoofingBook">
                <div className="MainBannerLeftRight">
                    <h1>Book Your Roofing Online Now in {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h1>
                    <h4>Top-Rated <b>Roofing Service</b></h4>
                    <h2>Rocket Air Care: Your Trusted Roofing Team in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b>. 📅 Schedule Your Appointment Online in less then a Minute</h2>
                    <h3><img src={require(`../../Images/check.png`)} /> Affordable Pricing & No Hidden Fees – Book Online Today!</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Licensed, Bonded, & Insured Professionals Ready to Serve You</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Fully Stocked Trucks for Next-Day Service – Schedule Now!</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Trusted by 1800+ 5-Star Reviews – Join Our Happy Customers!</h3>
                    <div className="MainBannerLeftButtons" id="book">
                        <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>Call Us Now!</a>
                        <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    </div>
                    <div className="MainBannerLeftRated">
                        <h3>Rated 5 on Google</h3>
                        <span>
                            <h4>5</h4>
                            <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                        </span>
                    </div>
                </div>
                <div className="MainBannerLeftLeft">
                    <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                </div>

            </div>
            {/* RoofingHowit work */}
            <div className="RoofingHowIt">
                <h1>How It Works</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>All It Takes Is Three Easy Steps</h2>
                <div className="RoofingHowItList">
                    <div className="RoofingHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit1.png`)} />
                        <h3>STEP 1</h3>
                        <h4>Call Our Office</h4>
                        <h5>Give us a call at <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}</a> to speak with one of our roofing specialists and schedule an appointment.</h5>
                    </div>
                    <div className="RoofingHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit2.png`)} />
                        <h3>STEP 2</h3>
                        <h4>On-Site Roof Inspection</h4>
                        <h5>We’ll send a licensed roofer to inspect your roof, assess any damage, and provide a detailed report with service options.</h5>
                    </div>
                    <div className="RoofingHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit3.png`)} />
                        <h3>STEP 3</h3>
                        <h4>Repair or Replace</h4>
                        <h5>Once approved, our crew will complete the necessary repairs or replacement—quickly, cleanly, and professionally.</h5>
                    </div>
                </div>
                <h6>Give us a call at <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}</a> to get started.</h6>
            </div>
            {/* MainBanner2Top2 */}
            <div className="RoofingServices" id="ourservices">
                <div className="MainBanner2TopBoxMenu">

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/rooofbanner.png`)} alt="Roof Repair Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>ROOF REPAIR</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Leak Detection & Fixes</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Shingle & Tile Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Storm & Wind Damage Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Flashing & Vent Repairs</h2>
                            </div>
                            <h4>Don't let roof damage grow into a major problem. Rocket Roofing provides fast and effective roof repair solutions for leaks, missing shingles, flashing damage, and more. Our team responds quickly to restore the integrity of your roof and protect your home from the elements.</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roofreplacement.png`)} alt="Roof Replacement Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>ROOF REPLACEMENT</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Full Tear-Off & Re-Roofing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Shingle, Tile, or Metal Options</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Insurance Claim Assistance</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Long-Term Warranty Coverage</h2>
                            </div>
                            <h4>If your roof is beyond repair or reaching the end of its lifespan, Rocket Roofing provides expert roof replacement services using top-grade materials. We handle everything from tear-off to installation, ensuring your new roof is durable, attractive, and built to last.</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roofinspection.png`)} alt="Roof Inspection Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>ROOF INSPECTION</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Annual Roof Health Checks</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Pre/Post-Storm Inspections</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Real Estate Certification</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Preventative Maintenance Reports</h2>
                            </div>
                            <h4>Protect your investment with a professional roof inspection. Our certified inspectors evaluate your roof for signs of wear, damage, and hidden risks—providing detailed reports and expert guidance on any necessary repairs or preventative care.</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roofemergency.png`)} alt="Leak Protection Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>LEAK PREVENTION</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Waterproof Coating Application</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Chimney & Skylight Sealing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Gutter & Downspout Protection</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Custom Drainage Solutions</h2>
                            </div>
                            <h4>Don’t let small leaks lead to big damage. Rocket Roofing offers expert leak prevention services, including flashing repair, waterproofing, and chimney sealing. Our proactive solutions help protect your roof from future water intrusion and costly repairs.</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roofinstall.png`)} alt="Gutter Installation & Repair Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>GUTTER INSTALLATION & REPAIR</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />New Gutter Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Gutter Leak Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Downspout Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Clog & Overflow Prevention</h2>
                            </div>
                            <h4>Properly functioning gutters are essential to protecting your roof, foundation, and landscaping. Rocket Roofing offers professional gutter installation and repair services to ensure rainwater is safely diverted away from your home. Whether you're dealing with leaks, sagging sections, or old systems in need of replacement, we’ve got you covered.</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roof1.png`)} alt="Emergency Roof Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>EMERGENCY ROOF SERVICES</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />24/7 Emergency Response</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Emergency Leak Tarping</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Storm & Wind Damage Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Temporary Structural Protection</h2>
                            </div>
                            <h4>Roof emergencies can happen at any time. Whether it's due to a storm, fallen tree, or sudden leak, Rocket Roofing offers rapid-response emergency services to secure your property and prevent further damage. Call us 24/7 for fast, professional help when you need it most.</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roofventn.png`)} alt="Roof Ventilation Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>VENTILATION SERVICES</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Attic Ventilation Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Ridge & Soffit Vent Systems</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Roof Vent Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Moisture & Heat Control</h2>
                            </div>
                            <h4>Proper ventilation extends the life of your roof and improves indoor comfort. Rocket Roofing offers professional ventilation solutions including ridge vents, soffit vents, and attic fan installation to promote airflow, reduce moisture buildup, and increase energy efficiency year-round.</h4>
                        </div>
                    </a>

                </div>
            </div>
            {/* MainBanner4 */}
            <div className="MainBanner4">
                <div className="MainBanner4Right">
                    <h1>Our Comprehensive Roofing Services</h1>
                    <h2>At Rocket Roofing, we offer a full suite of residential and commercial roofing solutions tailored to protect your home, increase energy efficiency, and enhance curb appeal. Our services include expert roof repair, full roof replacement, detailed inspections, leak protection, and more. With years of experience and quality workmanship, we ensure long-lasting results that stand up to the elements. Trust Rocket Roofing to keep your roof in top shape!</h2>
                    <div className="MainBafnner4RightBenefits">
                        <a>Roof repair</a>
                        <a>Shingle roof replacement</a>
                        <a>Flat roofing systems</a>
                        <a>New roof installation</a>
                        <a>Tile & metal roofing</a>
                        <a>Roof inspections</a>
                        <a>Storm damage repair</a>
                        <a>Roof leak detection</a>
                        <a>Emergency roof tarping</a>
                        <a>Insurance claim assistance</a>
                        <a>Licensed & insured roofing</a>
                        <a>Affordable roofing solutions</a>
                        <a>Flashing & vent repairs</a>
                        <a>Chimney flashing sealing</a>
                        <a>Gutter & drainage solutions</a>
                        <a>Annual maintenance plans</a>
                        <a>Energy-efficient roofing</a>
                        <a>Same-day roof assessments</a>
                        <a>Residential & commercial roofing</a>
                        <a>High-wind zone roofing systems</a>
                    </div>
                </div>
            </div>
            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h1>ABOUT OUR {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : ""} LOCATION</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="HomePageGoogleFAQTop">
                    <div className="HomePageGoogleFAQTopLeft">
                        <h2>PROUDLY SERVING OUR LOCAL COMMUNITY</h2>
                        <div className="HomePageGoogleFAQBorder"></div>
                        <h3>At Rocket Roofing, we proudly serve the community of {CitiesData && CitiesData.City ? CitiesData.City : ""} with expert roofing services built on over 22 years of trust, experience, and customer satisfaction. Whether you need a quick repair, full replacement, or a routine inspection, our team is here to help protect your home with reliable, long-lasting roofing solutions tailored to your needs.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a href='#book'>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Roof Inspection & Repair Near Me | Rocket Roofing" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFAQTopRight">
                        <img src={require(`../../ImagesLogos/logobanner.png`)} />
                    </div>
                </div>
                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>

        </div>
    )
}

